Wee.fn.make('stories', {
	init: function() {
		var scope = this,
			$input = $('ref:storiesInput'),
			$label = $('ref:storiesLabel'),
			$wrapper = $('ref:inputWrapper');

		if ($('ref:weeTopAlert').length) {
			$('ref:storiesHeading').css('top', 21.7 + 'rem');
		}

		if ($input.val()) {
			$label.hide().deactivate();
			$wrapper.deactivate();
		}

		$.events.on({
			'ref:storiesLabel': {
				click: function(e, el) {
					var $el = $(el);

					if ($el.hasClass('js-hide')) {
						$el.show();
						$wrapper.activate();
					} else {
						$el.hide();
						$el.next()[0].focus();
					}
				}
			},

			'ref:searchForm': {
				submit: function(e, el) {
					scope.filter($(el).serialize(true));

					e.preventDefault();
				}
			},

			'ref:filterLabel': {
				click: function(e, el) {
					var $radio = $(el).prev('ref:filterCheckbox');

					if ($radio.data('checked')) {
						$radio.data('checked', false);
						$radio.prop('checked', false);
					} else {
						$radio.data('checked', true);
						$radio.prop('checked', true);
					}

					$radio.siblings('ref:filterCheckbox')
						.data('checked', false);

					e.preventDefault();
				}
			},

			'ref:storiesInput': {
				focus: function() {
					$label.hide();
				},
				blur: function(e) {
					if (e.target.value === '') {
						$label.show().activate();
						$wrapper.activate();
					}
				}
			},

			'ref:filtersToggle': {
				click: function(e, el) {
					var $el = $(el),
						$form = $('ref:filtersForm'),
						$alert = $('ref:weeTopAlert'),
						$header = $('ref:header'),
						headerHeight;

					if ($alert.length) {
						headerHeight = $header.height() + $alert.height() + 'px';
					} else {
						headerHeight = $header.height() + 'px';
					}

					$form.toggleActive().css('top', headerHeight);
					$($._body).toggleEnable();

					$el.text($form.isActive() ? 'Back' : 'Filter');
				}
			},

			'ref:filtersForm': {
				submit: function(e, el) {
					var $filterSubmit = $('ref:filterSubmit');

					$filterSubmit
						.html('<span class="spinner"></span>')
						.addClass('spin');

					scope.filter($(el).serialize(true));

					setTimeout(function() {
						$filterSubmit
							.text('Success')
							.removeClass('spin')
							.addClass('success');

						setTimeout(function() {
							$('ref:filters').disable();
							$('ref:html').enable();
							$filterSubmit.removeClass('success').text('See Results');
							$('.spinner').remove();
						}, 500);
					}, 1000);

					$($._body).enable();

					e.preventDefault();
				}
			},

			'ref:filterDropdown': {
				change: function(e, el) {
					scope.filter({
						order: el.value
					});
				}
			},

			'ref:sortDropdown': {
				change: function(e, el) {
					scope.filter({
						category: el.value
					});
				}
			}

		}, {
			namespace: 'stories'
		});
	},
	filter: function(filters) {
		var currentFilters = $.routes.uri().query;

		filters = $.extend(currentFilters, filters);

		for (var filter in filters) {
			if (filters.hasOwnProperty(filter)) {
				if (filters[filter] === '') {
					delete filters[filter];
				}
			}
		}

		$.history.go({
			path: $.routes.uri().path + '?' + $.serialize(filters)
		});
	},
	unload: function() {
		$.events.off(null, '.stories');
	}
});
